import * as React from "react";
const SvgFiRrExternalHardDrive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-external-hard-drive_svg__a)">
      <path
        fill="#062147"
        d="M11 19.5c0 .83-.67 1.5-1.5 1.5S8 20.33 8 19.5 8.67 18 9.5 18s1.5.67 1.5 1.5m2.5-1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5M24 11.5v3a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1-1.414V4.5C21 3.121 19.879 2 18.5 2h-6c-1.207 0-2.217.86-2.45 2h3.45C15.981 4 18 6.019 18 8.5v11c0 2.481-2.019 4.5-4.5 4.5h-9A4.505 4.505 0 0 1 0 19.5v-11C0 6.019 2.019 4 4.5 4h3.528c.25-2.247 2.16-4 4.472-4h6C20.981 0 23 2.019 23 4.5v5.586a1.5 1.5 0 0 1 1 1.414m-8 8V17H2v2.5C2 20.879 3.122 22 4.5 22h9c1.379 0 2.5-1.121 2.5-2.5M13.5 6h-9A2.503 2.503 0 0 0 2 8.5V15h14V8.5C16 7.121 14.879 6 13.5 6"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-external-hard-drive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrExternalHardDrive;
